// header.js — predictive search + header interactions. Extracted from sections/header.liquid.
// The search URL is read from the header search form (was a Liquid interpolation).

// Mobile nav is a left slide-in drawer: toggle the nav + a backdrop + a body scroll-lock
  // together so the page behind it (visible through the right-hand gap) can't scroll.
  (function () {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    var overlay = document.querySelector('[data-mnav-overlay]');
    if (!nav) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('mnav-lock', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    window.__closeMobileNav = function () { setOpen(false); };
    window.__openMobileNav = function () { setOpen(true); };   // shared opener (used by the mobile bottom-nav Shop button)
    if (toggle) toggle.addEventListener('click', function () { setOpen(!nav.classList.contains('is-open')); });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
    var closeBtn = nav.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); if (toggle) toggle.focus(); });
  })();
  // Escape closes any open desktop mega-menu panel (they open on hover/focus-within;
  // blurring the focused item collapses the :focus-within panel) and the mobile nav.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.activeElement && document.activeElement.closest && document.activeElement.closest('.mega-item')) {
      document.activeElement.blur();
    }
    if (document.querySelector('[data-mobile-nav].is-open') && window.__closeMobileNav) {
      window.__closeMobileNav();
      var t = document.querySelector('[data-menu-toggle]'); if (t) t.focus();
    }
  });

  // Mobile nav: tap a category to expand its sub-list (accordion). Sub-links navigate.
  document.querySelectorAll('.mobile-nav .mega-link').forEach(function (link) {
    var item = link.closest('.mega-item');
    var panel = item && item.querySelector('.mega-panel');
    // The top-level tap only toggles the accordion, so the category's own collection page
    // was unreachable on mobile (the desktop "Shop all X" lifestyle tile is hidden here).
    // Inject a plain "Shop all X" link at the top of each panel so it's reachable.
    if (panel && !panel.querySelector('.mobile-shopall')) {
      var href = link.getAttribute('href');
      if (href) {
        var sa = document.createElement('a');
        sa.className = 'mobile-shopall';
        sa.href = href;
        // Avoid doubling when the top-level label already starts with "Shop all"
        // (e.g. "Shop All Departments" → don't render "Shop all Shop All Departments").
        var lbl = link.textContent.trim();
        sa.textContent = /^shop all/i.test(lbl) ? lbl : ('Shop all ' + lbl);
        panel.insertBefore(sa, panel.firstChild);
      }
    }
    link.addEventListener('click', function (e) {
      if (!item || !panel) return;
      e.preventDefault();
      item.classList.toggle('is-open');
    });
  });

  // Cycling "typewriter" search placeholder — prompts shoppers to search
  (function () {
    var inputs = document.querySelectorAll('input[type="search"][name="q"]');
    if (!inputs.length || inputs[0].value) return;
    // Example searches only, taken from the store's real top searches (2026-10-02: the slogan line went).
    // Phones: short prompts that fit the narrow box.
    var phrases = window.matchMedia('(max-width: 749px)').matches ? [
      'Search desks, rugs…',
      'Try “standing desk”…',
      'Try “rug”…',
      'Try “mattress”…',
      'Try “TV stand”…'
    ] : [
      'Search desks, rugs, mattresses…',
      'Try “standing desk”…',
      'Try “coffee table”…',
      'Try “chest of drawers”…',
      'Try “folding mattress”…',
      'Try “shoe storage”…',
      'Try “gazebo”…'
    ];
    var pi = 0, ci = 0, deleting = false;
    function set(txt) {
      inputs.forEach(function (el) { if (el !== document.activeElement) el.setAttribute('placeholder', txt || ' '); });
    }
    function tick() {
      var p = phrases[pi];
      ci += deleting ? -1 : 1;
      set(p.substring(0, ci));
      var delay = deleting ? 35 : 70;
      if (!deleting && ci === p.length) { deleting = true; delay = 1700; }
      else if (deleting && ci === 0) { deleting = false; pi = (pi + 1) % phrases.length; delay = 350; }
      setTimeout(tick, delay);
    }
    inputs.forEach(function (el) {
      el.addEventListener('focus', function () { el.setAttribute('placeholder', 'Search desks, rugs, mattresses…'); });
    });
    setTimeout(tick, 1200);
  })();

  // Predictive-search autocomplete: a suggestions dropdown under the search box,
  // powered by Shopify's /search/suggest.json (no app needed). Debounced, closes on
  // Escape / outside-click, and falls back to the normal search page on submit.
  (function () {
    // The search route comes from the header form action (this file is a static asset,
    // so no Liquid) — both header search forms post to routes.search_url.
    var _searchForm = document.querySelector('form[role="search"]');
    var ALL = (_searchForm && _searchForm.getAttribute('action')) || '/search';
    document.querySelectorAll('[data-search]').forEach(function (box) {
      var input = box.querySelector('[data-search-input]');
      var panel = box.querySelector('[data-search-results]');
      if (!input || !panel) return;
      var timer, last = '';
      var defTpl = box.querySelector('[data-search-default]');
      var defaultHTML = defTpl ? defTpl.innerHTML : '';
      var active = -1;
      function items() { return panel.querySelectorAll('.search-suggest__item, .ps-chip'); }
      function setActive(idx) {
        var els = items(); if (!els.length) { active = -1; return; }
        active = ((idx % els.length) + els.length) % els.length;          // wrap top↔bottom
        els.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        els[active].scrollIntoView({ block: 'nearest' });
      }
      function close() { panel.hidden = true; panel.innerHTML = ''; active = -1; }
      // pictures, at the top of the empty-search panel. Same localStorage list the homepage strip uses.
      var rvHTML = null;
      function loadRV() {
        if (rvHTML !== null) return Promise.resolve(rvHTML);
        var list = []; try { list = JSON.parse(localStorage.getItem('jshop_rv')) || []; } catch (e) {}
        list = list.slice(0, 6);
        if (!list.length) { rvHTML = ''; return Promise.resolve(''); }
        return Promise.all(list.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (ps) {
          var cards = ps.filter(function (p) { return p && p.available !== false; }).map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
            return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : '') + '<span>' + esc(p.title) + '</span></a>';
          }).join('');
          rvHTML = cards ? '<div class="search-suggest__head">Recently viewed</div><div class="search-suggest__rv">' + cards + '</div>' : '';
          return rvHTML;
        });
      }
      function showDefault() {
        active = -1; if (!defaultHTML) { close(); return; }
        panel.innerHTML = (rvHTML || '') + defaultHTML; panel.hidden = false;
        if (rvHTML === null) loadRV().then(function (h) { if (h && !panel.hidden && !input.value.trim()) panel.innerHTML = h + defaultHTML; });
      }
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      // Fallback only (used when the Liquid-rendered panel below cannot be fetched): the plain JSON
      // suggestions, with small thumbnails and the from-price.
      function render(data) {
        active = -1;
        var r = data && data.resources && data.resources.results;
        var items = (r && r.products) || [];
        if (!items.length) { panel.innerHTML = '<div class="search-suggest__empty">No quick matches. Press Enter for a full search, or <a href="/collections/all">browse all products</a>.</div>'; panel.hidden = false; return; }
        var html = items.slice(0, 7).map(function (it) {
          var src = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var img = src ? '<img src="' + esc(src) + '" alt="" loading="eager" decoding="async" width="56" height="56">' : '<span class="search-suggest__noimg"></span>';
          var price = it.price ? '<span class="ps-price"><span class="ps-price__now">' + (it.price_max && it.price_max !== it.price_min ? 'From ' : '') + '€' + esc(String(it.price).replace(/\.00$/, '')) + '</span></span>' : '';
          return '<a class="search-suggest__item ps-prod" href="' + esc(it.url) + '">' + img + '<span class="search-suggest__txt"><span class="search-suggest__t">' + esc(it.title) + '</span>' + price + '</span></a>';
        }).join('');
        html += '<a class="search-suggest__all" href="' + ALL + '?q=' + encodeURIComponent(input.value) + '&type=product">See all results →</a>';
        panel.innerHTML = html;
        panel.hidden = false;
      }
      // Department match per query (from the panel's data-exact): Enter on "desk" opens the Desks department.
      var exact = {};
      function norm(q) { return String(q || '').trim().toLowerCase().replace(/\s+/g, ' '); }
      function renderPanel(html, q) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var ps = tmp.querySelector('[data-ps]');
        if (!ps) return false;
        exact[norm(q)] = ps.getAttribute('data-exact') || '';
        if (norm(input.value) !== norm(q)) return true;          // a newer query is on its way
        active = -1;
        panel.innerHTML = ps.innerHTML || '<div class="search-suggest__empty">No quick matches. Press Enter for a full search.</div>';
        panel.hidden = false;
        return true;
      }
      function go() {
        var q = input.value.trim();
        if (q.length < 2) { showDefault(); return; }
        if (q === last) { if (panel.innerHTML) panel.hidden = false; return; }
        last = q;
        // Shimmer skeleton rows while the suggestions are fetched.
        panel.innerHTML = new Array(4).join('<div class="search-suggest__skel"><span class="s1"></span><span class="s2"></span></div>') + '<div class="search-suggest__skel"><span class="s1"></span><span class="s2"></span></div>';
        panel.hidden = false;
        // unavailable_products=HIDE, not `last`. `last` only sorts sold-out suggestions to the
        // bottom — they are still returned, still clickable, and a shopper reached a sold-out wine
        // rack straight from this dropdown. This panel builds its own markup from suggest.json, so
        // the sold-out hiding in product-card.liquid never applied here; the exclusion has to come
        // from the API itself.
        // Liquid-rendered panel (sections/main-search.liquid, predictive branch): departments, query
        // completions and products with price, RRP and saving. Falls back to the JSON suggestions.
        var base = '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=7&resources[limit_scope]=each&resources[options][unavailable_products]=hide';
        fetch('/search/suggest' + base + '&section_id=main-search', { headers: { 'Accept': 'text/html' } })
          .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
          .then(function (html) { if (!renderPanel(html, q)) throw new Error('no panel'); })
          .catch(function () {
            return fetch('/search/suggest.json' + base, { headers: { 'Accept': 'application/json' } })
              .then(function (res) { return res.json(); })
              .then(function (d) { if (norm(input.value) === norm(q)) render(d); });
          })
          .catch(function () { last = ''; close(); });
          // reset `last` so a network blip doesn't permanently mute suggestions for THIS query
          // (the go() guard skips a re-fetch while q === last).
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(go, 180); });
      input.addEventListener('focus', go);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); input.blur(); return; }
        if (panel.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Enter') { var els = items(); if (active >= 0 && els[active]) { e.preventDefault(); window.location.href = els[active].href; } }
      });
      // Enter on a department's exact name ("desk", "desks", "standing desk") opens that department
      // instead of the loose keyword results. Anything else searches as before.
      var form = box.querySelector('form');
      if (form) form.addEventListener('submit', function (e) {
        var url = exact[norm(input.value)];
        if (url) { e.preventDefault(); window.location.href = url; }
      });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    });
  })();

// Desktop mega-menu "hover intent" (2026-09-26). The panels used to open on pure CSS :hover, so
// moving from one menu word to the next crossed the small gap between them, the first panel
// - once a panel is open, moving to another item swaps it instantly (nothing closes in between);
// - opening from closed waits 80ms, so a cursor just passing over the bar doesn't pop panels;
// - leaving the menu closes it after a 250ms grace, so a slightly wobbly path doesn't snap it shut;
// - the panel pictures are fetched on the first touch of the bar, so they never appear blank.
// Keyboard (:focus-within) and the phone menu are unchanged.
(function () {
  var nav = document.querySelector('.header__nav-bar');
  if (!nav || !window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 1024px) and (hover: hover)');
  var items = [].slice.call(nav.querySelectorAll('.mega-item'));
  var open = null, tOpen = 0, tClose = 0, warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    nav.querySelectorAll('.mega-panel img').forEach(function (i) { i.loading = 'eager'; });
    nav.querySelectorAll('.mega-panel [style*="url("]').forEach(function (e) {
      var m = (e.getAttribute('style') || '').match(/url\(['"]?([^'")]+)/); if (m) { var im = new Image(); im.src = m[1]; }
    });
  }
  function show(it) {
    clearTimeout(tClose);
    if (open === it) return;
    var a = document.activeElement, mi = a && a.closest ? a.closest('.mega-item') : null;
    if (mi && mi !== it && nav.contains(mi)) a.blur();   // a clicked item keeps :focus-within open otherwise
    nav.setAttribute('data-switch', open && it ? '1' : '0');
    if (open) open.classList.remove('is-open');
    open = it || null;
    if (open) open.classList.add('is-open');
    nav.classList.toggle('mega-active', !!open);
  }
  items.forEach(function (it) {
    it.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      warm(); clearTimeout(tOpen); clearTimeout(tClose);
      if (open) show(it); else tOpen = setTimeout(function () { show(it); }, 80);
    });
  });
  nav.addEventListener('mouseenter', function () { clearTimeout(tClose); });
  // Fetch the panel pictures early: when the mouse enters the header (on its way to the menu).
  // Desktop/hover devices only, so phones never pay for it, and visitors who never reach the menu don't either.
  var hdr = nav.closest('header') || document.querySelector('.header');
  if (hdr) hdr.addEventListener('mouseenter', function () { if (mq.matches) warm(); });
  nav.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(function () { show(null); }, 250); });
  nav.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.mega-panel a')) show(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') show(null); });
  window.addEventListener('scroll', function () { if (open && window.scrollY > 400) show(null); }, { passive: true });
  document.documentElement.classList.add('js-mega');
})();

// Phone header search icon (2026-10-04, mobile space). On home/collection/search pages the box is already under the
// header: the icon just focuses it. Elsewhere it opens that same box (predictive search included) as an overlay under
// the header row with the input focused; a tap outside, Escape or the icon again closes it. focus() runs inside the tap
// (iOS ignores a deferred focus and would not raise the keyboard), then the focus event is re-sent on the next frame so
// the zero-query suggestions show even if a stray outside-click close fired.
(function () {
  var btn = document.querySelector('[data-search-open]');
  var hdr = document.querySelector('.header');
  var wrap = document.getElementById('hdr-msearch');
  if (!btn || !hdr || !wrap) return;
  var input = wrap.querySelector('[data-search-input]');
  function isOpen() { return hdr.classList.contains('is-search-open'); }
  function setOpen(o) { hdr.classList.toggle('is-search-open', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
  btn.addEventListener('click', function (ev) {
    ev.preventDefault(); ev.stopPropagation();
    if (isOpen()) { setOpen(false); return; }
    if (getComputedStyle(wrap).display === 'none') setOpen(true);
    if (!input) return;
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    requestAnimationFrame(function () { try { input.dispatchEvent(new Event('focus')); } catch (e) {} });
    if (window.scrollY > 0 && hdr.getBoundingClientRect().top < 0) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) { if (isOpen() && !wrap.contains(e.target) && !btn.contains(e.target)) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { setOpen(false); btn.focus(); } });
})();
